import React, { useState } from 'react';
import styled from 'styled-components';
import FormSectionEditor from '../components/FormSectionEditor';
import { useFormContext } from '../FormContext';
import { useFormDragContext } from '../FormDragContext';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { Button, CircularProgress, Typography } from '@material-ui/core';
import FormDialog from '../dialogs/FormDialog';
import { Check as CheckIcon } from '@material-ui/icons';
import { Virtuoso } from 'react-virtuoso';
const StyledDiv = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
  .form-toolbar {
    display: flex;
    padding: 8px 12px;
    background: #fff;
    /* border-bottom: 1px solid #ccc; */
    box-shadow: 0 2px 4px #ccc;
    z-index: 1;
    align-items: center;
    .save-status {
      margin-left: 10px;
    }
    .flex {
      flex: 1;
    }
  }
  .form-sections {
    flex: 1;
  }
`;
export const FormEditPanel = ({ isSaved, isSaving, saveLabel }) => {
    const { formSections } = useFormContext();
    const { formEditPanelRef } = useFormDragContext();
    const [openPreview, setOpenPreview] = useState(false);
    return (React.createElement(StyledDiv, { className: 'form-edit-panel', ref: formEditPanelRef },
        React.createElement("div", { className: 'form-toolbar' },
            isSaving && (React.createElement(React.Fragment, null,
                React.createElement(CircularProgress, { size: 20 }),
                React.createElement(Typography, { variant: 'caption', className: 'save-status' }, saveLabel || 'Saving...'))),
            !isSaving && isSaved && (React.createElement(React.Fragment, null,
                React.createElement(CheckIcon, { fontSize: 'small' }),
                React.createElement(Typography, { variant: 'caption', className: 'save-status' }, "Saved"))),
            React.createElement("div", { className: 'flex' }),
            React.createElement(Button, { color: 'primary', startIcon: React.createElement(VisibilityIcon, null), onClick: () => setOpenPreview(true) }, "Preview")),
        React.createElement(Virtuoso, { className: 'form-sections', data: formSections, itemContent: (index, stateNode) => (
            // NOTE: Do not place any elements adjacent to FormSectionEditor;
            // otherwise, the sorting will break
            React.createElement(FormSectionEditor, { key: stateNode.name, index: index, stateNode: stateNode })) }),
        openPreview && (React.createElement(FormDialog, { preview: true, open: openPreview, onCancel: () => setOpenPreview(false) }))));
};
export default FormEditPanel;
//# sourceMappingURL=FormEditPanel.js.map